import React, { ReactElement } from "react"
import styled from "styled-components"
import { theme } from "../../theme"

type AddressesProps = {
  children?: Array<ReactElement>
}

export const AddressGroup = (props: AddressesProps) => {
  const { children } = props

  return (
    <AddressGroupWrapper>
      {children?.map((child, index) =>
        React.cloneElement(child, {
          ...child.props,
          id: index,
        })
      )}
    </AddressGroupWrapper>
  )
}

const AddressGroupWrapper = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-gap: ${theme.spacing.l};
`
